import script from "./ProductComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProductComponent.vue?vue&type=style&index=0&id=7be5191d&lang=scss&scoped=true"
import "./ProductComponent.vue?vue&type=style&index=1&id=7be5191d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be5191d"]])

export default __exports__